"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StitchReadOperationServer_1 = __importDefault(require("./StitchReadOperationServer"));

var StitchCollectionServer =
/** @class */
function () {
  function StitchCollectionServer(coll) {
    this.coll = coll;
    this.namespace = coll.namespace;
  }

  StitchCollectionServer.prototype.count = function (query, options) {
    return this.coll.count(query, options);
  };

  StitchCollectionServer.prototype.find = function (query, options) {
    return new StitchReadOperationServer_1.default(this.coll.find(query, options));
  };

  StitchCollectionServer.prototype.findOne = function (query, options) {
    return this.coll.findOne(query, options);
  };

  StitchCollectionServer.prototype.findOneAndUpdate = function (query, update, options) {
    return this.coll.findOneAndUpdate(query, update, options);
  };

  StitchCollectionServer.prototype.findOneAndDelete = function (query, options) {
    return this.coll.findOneAndDelete(query, options);
  };

  StitchCollectionServer.prototype.updateOne = function (query, update, updateOptions) {
    return this.coll.updateOne(query, update, updateOptions);
  };

  StitchCollectionServer.prototype.updateMany = function (query, update, updateOptions) {
    return this.coll.updateMany(query, update, updateOptions);
  };

  StitchCollectionServer.prototype.insertOne = function (doc) {
    return this.coll.insertOne(doc);
  };

  StitchCollectionServer.prototype.watch = function (arg) {
    return this.coll.watch(arg);
  };

  StitchCollectionServer.prototype.aggregate = function (pipeline) {
    var prom = this.coll.aggregate(pipeline).asArray();
    return prom;
  };

  StitchCollectionServer.prototype.delete = function (query) {
    return this.coll.deleteOne(query);
  };

  return StitchCollectionServer;
}();

exports.default = StitchCollectionServer;